export enum HistoryChangeTypes {
  CHANGED = 'changed',
  CREATED = 'created',
  DELETED = 'deleted',
  SINGLE_COMMENT = 'single_comment',
  APPLICATION_LINK = 'application_link',
  STRING_LIST_CHANGED = 'string_list_changed',
  ASSIGNED_ENTITIES_CHANGED = 'assigned_entities_changed'
}
